
import { Vue, Component, Ref } from "vue-property-decorator";
import md5 from 'js-md5'
@Component({
  name: "Login",
})
export default class Login extends Vue {
  @Ref("form") formRef: any;

  private form = {
    username: "",
    password: "",
  };

  private rules = {
    username: [{ required: true, message: "请输入账号", trigger: "change" }],
    password: [{ required: true, message: "请输入密码", trigger: "change" }],
  };

  mounted() {
    console.log("route:", this.$route);
  }

  onSubmit() {
    this.formRef.validate((valid: boolean) => {
      if (valid) {
		const username = this.form.username;
		const pwd = this.form.password;
        if (username === "admin" && pwd === "!Q@W3e4r") {
			
		  let loginName = username;
		  let password = md5(pwd);
		  let paramter = {
		  	loginName,
		  	password,
		  };
		  this.$http.post("login", paramter).then((res: any) =>{
		  	
		  	this.tableData = res.data.data;
			this.$message.success(this.tableData.name);
			this.$Cookies.set("vue_admin_token", this.tableData.token, { expires: 1 });
			this.$Cookies.set("vue_admin_name", this.tableData.name, { expires: 1 });
			
			const redirect = this?.$route?.query?.redirect as string;
			if (redirect) this.$router.push(redirect);
			else this.$router.push("/");
		  });
		  
        } else {
          this.$message.warning("请检查账号密码！");
        }
      } else {
        return false;
      }
    });
  }

}
